<app-dialog [title]="data.title" (close)="close()">
    <ng-container dialogHeader>
        <ng-container [ngTemplateOutlet]="panelTools"></ng-container>
    </ng-container>
    <ng-container dialogContent>
        <div #formRef
             class="languages-dialog-form-container"
             [formGroup]="form"
             (keydown)="data.access?.edit ? keyDownFunction($event) : null">
            <div fxLayout="row wrap" fxLayoutAlign="flex-start"
                 ngClass.gt-sm="fx-flex-row-margin-right">
                <div [fxFlex]="'0 1 100%'"
                     *ngFor="let lang of appService?.languages | keyvalue"
                     [class.!hidden]="lang?.value != currentLangForm">
                    <ng-container dynamic-field [field]="{
                        type: 'input',
                        label: appService.language_dictionary.system_name + (appService.languageCount > 1 ? ' (' + lang?.value?.lang + ')' : ''),
                        inputType: 'text',
                        name: lang?.value?.lang,
                        disabled: !data.access?.edit,
                        required: lang?.value?.lang == appService.defaultLanguage,
                        validations: [
                            {
                                name: 'required',
                                message: appService.language_dictionary.system_field_required
                            },
                            {
                                name: 'serverError'
                            }
                        ]
                        }" [group]="form?.get('name')"></ng-container>
                </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="flex-start"
                 ngClass.gt-sm="fx-flex-row-margin-right">
                <div [fxFlex]="'0 1 100%'"
                     *ngFor="let lang of appService?.languages | keyvalue"
                     [class.!hidden]="lang?.value != currentLangForm">
                    <ng-container dynamic-field [field]="{
                type: 'input',
                label: appService.language_dictionary.rubric_full_name + (appService.languageCount > 1 ? ' (' + lang?.value?.lang + ')' : ''),
                inputType: 'text',
                name: lang?.value?.lang,
                disabled: !data.access?.edit,
                validations: [
                    {
                        name: 'serverError'
                    }
                ]
                }" [group]="form?.get('full_name')"></ng-container>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <ng-container *ngIf="data.access?.edit">
            <fui-button
                (click)="save()"
                [label]="appService.language_dictionary.system_save"
                [color]="'primary'"
                [height]="'mini'"
                [icon]="'content-save'">
            </fui-button>
        </ng-container>
        <fui-button
            *ngIf="data.access?.edit"
            (click)="close()"
            [label]="appService.language_dictionary.system_cancel"
            [color]="'light'"
            [height]="'mini'"
            [icon]="'close'">
        </fui-button>
    </ng-container>
</app-dialog>

<ng-template #panelTools>
    <panel-tools
        showLangButton="{{ true }}"
        showRequiredLabel="{{ true }}"
        isPanelToolsDialog="{{ true }}"
        (setCurrentLangForm)="setCurrentLangForm($event)"
    >
    </panel-tools>
</ng-template>
